import React from 'react';
import { Form } from 'src/components/Antd';
const Item = Form.Item;
import { ETagType } from '../Settings';
import { get } from 'lodash';
import TagCondition from './TagCondition';
import RegisteredSalesChannel from './RegisteredSalesChannel';
import TotalSpend from './TotalSpend';
import RegisteredDate from './RegisteredDate';
import OrderDate from './OrderDate';
import NumberOfOrders from './NumberOfOrder';
import Promotion from './PromotionApplied';
import Language from './Language';
import ConsentAttribute from './ConsentAttributes';
import AbandonCheckout from './AbandonedCheckout';
import Subscription from './Subscription';
import ProductsInShoppingCart from './ProductsInShoppingCart';
import ProductsPurchased from './ProductsPurchased';
import TermsAndConditions from './TermsAndConditions';
import css from './css.module.less';

const Filter = (props) => {
  const { form, options, disabled } = props;

  const helpData = {
    registeredSalesChannel: {
      disabled,
      name: [
        'conditions',
        'registeredSalesChannelFilter',
        'selectedSalesChannelUuids',
      ],
      options: options.salesChannels,
      radioName: ['conditions', 'registeredSalesChannelFilter', 'policy'],
      root: ['conditions', 'registeredSalesChannelFilter'],
      state: {
        conditions: {
          registeredSalesChannelFilter: {
            policy: null,
            selectedSalesChannelUuids: [],
          },
        },
      },
    },
    totalSpend: {
      disabled,
      nameType: ['conditions', 'orderAmountFilter', 'policy'],
      nameValue: ['conditions', 'orderAmountFilter', 'value'],
      nameRange: ['conditions', 'orderAmountFilter', 'range'],
      root: ['conditions', 'orderAmountFilter'],
      suffix: options.currency || 'AUD',
      state: {
        conditions: {
          orderAmountFilter: {
            policy: null,
            value: null,
            range: { from: null, to: null },
          },
        },
      },
    },
    registeredDate: {
      disabled,
      selectName: ['conditions', 'registerDateFilter', 'registered'],
      daysName: ['conditions', 'registerDateFilter', 'days'],
      policyName: ['conditions', 'registerDateFilter', 'policy'],
      singleDayName: ['conditions', 'registerDateFilter', 'date'],
      dayRangeName: ['conditions', 'registerDateFilter', 'range'],
      root: ['conditions', 'registerDateFilter'],
      state: {
        conditions: {
          registerDateFilter: {
            registered: null,
            days: null,
            policy: null,
            date: null,
            range: [],
          },
        },
      },
    },
    orderDate: {
      disabled,
      selectName: ['conditions', 'orderDateFilter', 'searchCondition'],
      daysName: ['conditions', 'orderDateFilter', 'days'],
      policyName: ['conditions', 'orderDateFilter', 'policy'],
      singleDayName: ['conditions', 'orderDateFilter', 'date'],
      dayRangeName: ['conditions', 'orderDateFilter', 'range'],
      root: ['conditions', 'orderDateFilter'],
      state: {
        conditions: {
          orderDateFilter: {
            searchCondition: null,
            days: null,
            policy: null,
            date: null,
            range: [],
          },
        },
      },
    },
    numberOfOrders: {
      disabled,
      selectName: ['conditions', 'orderCountFilter', 'orderStatus'],
      nameRange: ['conditions', 'orderCountFilter', 'range'],
      nameValue: ['conditions', 'orderCountFilter', 'value'],
      nameType: ['conditions', 'orderCountFilter', 'policy'],
      root: ['conditions', 'orderCountFilter'],
      state: {
        conditions: {
          orderCountFilter: {
            orderStatus: null,
            policy: null,
            value: null,
            range: { from: null, to: null },
          },
        },
      },
    },
    promotionApplied: {
      disabled,
      radioName: ['conditions', 'discountFilter', 'include'],
      selectName: ['conditions', 'discountFilter', 'selectedDiscounts'],
      // selectOptions: [{ value: '1', label: '1' }],
      root: ['conditions', 'discountFilter'],
      options: options.promotions,
      state: {
        conditions: {
          discountFilter: {
            include: null,
            selectedDiscounts: null,
          },
        },
      },
    },
    language: {
      disabled,
      name: ['conditions', 'languageFilter', 'selectedLanguages'],
      root: ['conditions', 'languageFilter'],
      options: options.languages,
      state: {
        conditions: {
          languageFilter: {
            selectedLanguages: [],
          },
        },
      },
    },
    consentAttributes: {
      disabled,
      selectName: [
        'conditions',
        'consentAttributeFilter',
        'selectedConsentAttributes',
      ],
      root: ['conditions', 'consentAttributeFilter'],
      radioName: ['conditions', 'consentAttributeFilter', 'include'],
      options: options.consentAttribute,
      // hasExclude: true,
      state: {
        conditions: {
          consentAttributeFilter: {
            include: null,
            selectedConsentAttributes: [],
          },
        },
      },
    },
    abandonCheckout: {
      disabled,
      radioName: ['conditions', 'abandonCheckoutFilter', 'abandonedCheckout'],
      root: ['conditions', 'abandonCheckoutFilter'],
      state: {
        conditions: {
          abandonCheckoutFilter: {
            abandonedCheckout: null,
          },
        },
      },
    },
    subscription: {
      disabled,
      radioName: ['conditions', 'subscriptionFilter', 'subscribed'],
      root: ['conditions', 'subscriptionFilter'],
      state: {
        conditions: {
          subscriptionFilter: {
            subscribed: null,
          },
        },
      },
    },
    shoppingCart: {
      disabled,
      radioName: ['conditions', 'shoppingCartFilter', 'include'],
      listName: ['conditions', 'shoppingCartFilter', 'selectedProducts'],
      root: ['conditions', 'shoppingCartFilter'],
      state: {
        conditions: {
          shoppingCartFilter: {
            include: null,
            selectedProducts: [],
          },
        },
      },
    },
    productPurchased: {
      disabled,
      radioName: ['conditions', 'productPurchasedFilter', 'include'],
      listName: ['conditions', 'productPurchasedFilter', 'selectedProducts'],
      root: ['conditions', 'productPurchasedFilter'],
      state: {
        conditions: {
          productPurchasedFilter: {
            include: null,
            selectedProducts: [],
          },
        },
      },
    },
    tacFilter: {
      disabled,
      selectName: ['conditions', 'tacFilter', 'tacUuids'],
      root: ['conditions', 'tacFilter'],
      radioName: ['conditions', 'tacFilter', 'include'],
      options: options.salesChannelTacList,
      // hasExclude: true,
      state: {
        conditions: {
          tacFilter: {
            include: null,
            tacUuids: [],
          },
        },
      },
    },
  };

  return (
    <Item
      shouldUpdate={(p, c) => {
        const cT = get(c, 'tagType');
        const pT = get(p, 'tagType');
        return cT !== pT;
      }}>
      {(f) => {
        const { getFieldValue } = f;
        const type = getFieldValue('tagType');
        if (type === ETagType.Auto) {
          return (
            <div className={css.container}>
              <TagCondition form={form} disabled={disabled} />
              <RegisteredSalesChannel
                form={form}
                {...helpData.registeredSalesChannel}
              />
              <TotalSpend form={form} {...helpData.totalSpend} />
              <RegisteredDate form={form} {...helpData.registeredDate} />
              <OrderDate form={form} {...helpData.orderDate} />
              <NumberOfOrders form={form} {...helpData.numberOfOrders} />
              <ProductsInShoppingCart form={form} {...helpData.shoppingCart} />
              <ProductsPurchased form={form} {...helpData.productPurchased} />
              <Promotion form={form} {...helpData.promotionApplied} />
              <Language form={form} {...helpData.language} />
              <ConsentAttribute form={form} {...helpData.consentAttributes} />
              <TermsAndConditions form={form} {...helpData.tacFilter} />
              <AbandonCheckout form={form} {...helpData.abandonCheckout} />
              <Subscription form={form} {...helpData.subscription} />
              {/* <div style={{ opacity: 0 }}>123</div> */}
            </div>
          );
        }
        return null;
      }}
    </Item>
  );
};
export default Filter;
